import { render, staticRenderFns } from "./newpreviews.vue?vue&type=template&id=393b184b&scoped=true"
import script from "./newpreviews.vue?vue&type=script&lang=js"
export * from "./newpreviews.vue?vue&type=script&lang=js"
import style0 from "./newpreviews.vue?vue&type=style&index=0&id=393b184b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b184b",
  null
  
)

export default component.exports